import styled from 'styled-components';
import noop from 'utils/noop';
import { InputText } from 'ui/inputs';
import { ResourceComponentProps } from '../../../StartNodeEditor/resourceComponents/types';

const FullWidthInput = styled(InputText)`
  width: 100%;
`;

/**
 * This returns a text input field when required by the resourse selector
 *
 * NOTE: No longer used after StartTileRefresh is GA
 */
export const ResourceInput = ({
  isError,
  onChange = noop,
  value,
  ...props
}: ResourceComponentProps) => {
  return (
    <FullWidthInput
      {...props}
      value={value || ''}
      hasError={isError}
      data-formfieldtype="text"
      onChange={(v) => onChange({ label: v, value: v })}
    />
  );
};

export default ResourceInput;
